import React, { createContext, useState, useEffect, useContext } from 'react';
import { savePageContent, getPageContent } from '../services/api';

const LinksContext = createContext();

const generateId = () => Math.random().toString(36).substr(2, 9);

const initialData = {
    sectionTitle: 'EIXOS DE ATUAÇÃO',
    columns: [
        {
            id: 'col1',
            title: 'Capacidades',
            promise: 'Tecnologia de ponta para acelerar sua jornada digital.',
            items: [
                { id: 'c1-1', label: 'Cloud', description: 'Acelere sua jornada para a nuvem com nossa suíte completa de serviços e estratégia de migração segura.' },
                { id: 'c1-2', label: 'Customer Service', description: 'Transforme experiências do cliente com soluções de suporte e engajamento impulsionadas por IA.' },
                { id: 'c1-3', label: 'Cibersegurança', description: 'Proteja seus ativos digitais com monitoramento avançado, detecção de ameaças e respostas rápidas.' },
                { id: 'c1-4', label: 'Dados e IA', description: 'Desbloqueie o poder dos seus dados com análises avançadas e inteligência artificial generativa.' },
                { id: 'c1-5', label: 'Engenharia Digital', description: 'Inove seus processos de manufatura com gêmeos digitais, IoT e soluções de fábrica inteligente.' },
                { id: 'c1-6', label: 'Ecossistemas', description: 'Aproveite nossas alianças estratégicas para impulsionar valor, inovação e alcance de mercado.' },
                { id: 'c1-7', label: 'Tecnologias Emergentes', description: 'Esteja à frente da curva com blockchain, computação quântica e novas arquiteturas.' },
                { id: 'c1-8', label: 'Riscos e Finanças', description: 'Navegue por cenários regulatórios complexos e otimize o desempenho financeiro com precisão.' },
                { id: 'c1-9', label: 'Infraestrutura', description: 'Entregue projetos de infraestrutura de larga escala dentro do prazo e do orçamento.' },
                { id: 'c1-10', label: 'Learning', description: 'Capacite sua força de trabalho com nossos programas de treinamento e desenvolvimento de classe mundial.' }
            ]
        },
        {
            id: 'col2',
            title: 'Consultoria',
            promise: 'Estratégia e operações para definir o futuro do seu negócio.',
            items: [
                { id: 'c2-1', label: 'Serviços Gerenciados', description: 'Otimize operações de TI e foque no core business com nossa gestão abrangente de infraestrutura.' },
                { id: 'c2-2', label: 'Marketing e Experiência', description: 'Crie experiências de marca memoráveis que impulsionam lealdade e crescimento sustentável.' },
                { id: 'c2-3', label: 'Metaverso', description: 'Explore novas dimensões de engajamento na web imersiva e em ambientes virtuais.' },
                { id: 'c2-4', label: 'Vendas e Comércio', description: 'Capacite suas equipes de vendas e otimize canais de comércio para máxima conversão.' },
                { id: 'c2-5', label: 'Estratégia', description: 'Defina seu caminho para o sucesso com nossa consultoria estratégica baseada em dados.' },
                { id: 'c2-6', label: 'Supply Chain', description: 'Construa cadeias de suprimentos resilientes, eficientes e adaptáveis para o mundo moderno.' },
                { id: 'c2-7', label: 'Sustentabilidade', description: 'Incorpore a sustentabilidade em sua estratégia central de negócios para valor a longo prazo.' },
                { id: 'c2-8', label: 'Talento e Organização', description: 'Reimagine o trabalho, a cultura e capacite suas pessoas para a era digital.' },
                { id: 'c2-9', label: 'Transformação Tech', description: 'Modernize seu stack tecnológico para impulsionar agilidade, escala e inovação contínua.' }
            ]
        },
        {
            id: 'col3',
            title: 'Indústrias',
            promise: 'Conhecimento profundo para transformar sua área.',
            items: [
                { id: 'c3-1', label: 'Aeroespacial e Defesa', description: 'Inovando para um mundo mais seguro, conectado e tecnologicamente avançado.' },
                { id: 'c3-2', label: 'Automobilística', description: 'Impulsionando o futuro da mobilidade com soluções veiculares conectadas e autônomas.' },
                { id: 'c3-3', label: 'Banca', description: 'Transformando serviços financeiros para a era digital com segurança e agilidade.' },
                { id: 'c3-4', label: 'Mercado de Capitais', description: 'Navegando a volatilidade e impulsionando valor em mercados globais complexos.' },
                { id: 'c3-5', label: 'Química', description: 'Inovação sustentável e eficiência operacional para a indústria química.' },
                { id: 'c3-6', label: 'Mídia e Comunicações', description: 'Redefinindo o consumo de conteúdo, conectividade e monetização digital.' },
                { id: 'c3-7', label: 'Bens de Consumo', description: 'Atendendo às necessidades em evolução do consumidor digital com rapidez e personalização.' },
                { id: 'c3-8', label: 'Energia', description: 'Impulsionando a transição energética com soluções digitais e operacionais.' },
                { id: 'c3-9', label: 'Saúde', description: 'Melhorando resultados de pacientes através da inovação em saúde digital.' },
                { id: 'c3-10', label: 'Alta Tecnologia', description: 'Acelerando a inovação de produtos e o time-to-market em ambientes competitivos.' }
            ]
        },
        {
            id: 'col4',
            title: 'Áreas',
            promise: 'Soluções dedicadas para desafios específicos de mercado.',
            items: [
                { id: 'c4-1', label: 'Industrial', description: 'Otimizando operações industriais com tecnologias da Indústria 4.0 e automação.' },
                { id: 'c4-2', label: 'Seguros', description: 'Reinventando seguros com dados, IA e plataformas digitais centradas no cliente.' },
                { id: 'c4-3', label: 'Ciências da Vida', description: 'Avançando a descoberta e o cuidado nas ciências da vida com precisão e compliance.' },
                { id: 'c4-4', label: 'Recursos Naturais', description: 'Gestão sustentável e eficiente de recursos naturais com inteligência de dados.' },
                { id: 'c4-5', label: 'Área Pública', description: 'Modernizando serviços ao cidadão e operações governamentais para maior eficiência.' },
                { id: 'c4-6', label: 'Private Equity', description: 'Maximizando a criação de valor em todo o ciclo de vida do investimento.' },
                { id: 'c4-7', label: 'Varejo', description: 'Projetando o futuro do varejo com comércio unificado e experiências omnicanal.' },
                { id: 'c4-8', label: 'Software e Plataformas', description: 'Construindo e escalando as plataformas de amanhã com arquiteturas robustas.' },
                { id: 'c4-9', label: 'Turismo e Viagens', description: 'Reimaginando a experiência de viagem para o novo viajante global.' },
                { id: 'c4-10', label: 'Utilities', description: 'Transformando operações de serviços públicos para um futuro sustentável e confiável.' }
            ]
        }
    ]
};

const sanitizeLinkItem = (rawItem, fallbackItem = {}) => {
    if (typeof rawItem === 'string') {
        return { id: generateId(), label: rawItem, description: '' };
    }

    const source = rawItem && typeof rawItem === 'object' ? rawItem : {};
    const safeId = source.id || fallbackItem.id || generateId();

    return {
        ...source,
        id: safeId,
        label: (source.label || fallbackItem.label || '').toString(),
        description: (source.description || fallbackItem.description || '').toString()
    };
};

const sanitizeColumn = (rawColumn, fallbackColumn) => {
    const source = rawColumn && typeof rawColumn === 'object' ? rawColumn : {};
    const sourceItems = Array.isArray(source.items) ? source.items : [];
    const fallbackItems = Array.isArray(fallbackColumn.items) ? fallbackColumn.items : [];

    const normalizedItems = sourceItems.length
        ? sourceItems.map((item, index) => sanitizeLinkItem(item, fallbackItems[index]))
        : fallbackItems.map((item) => sanitizeLinkItem(item));

    return {
        ...fallbackColumn,
        ...source,
        id: source.id || fallbackColumn.id,
        title: (source.title || fallbackColumn.title || '').toString(),
        promise: (source.promise || fallbackColumn.promise || '').toString(),
        items: normalizedItems
    };
};

const sanitizeLinksData = (raw) => {
    const source = raw && typeof raw === 'object' ? raw : {};
    const sourceColumns = Array.isArray(source.columns) ? source.columns : [];

    const columns = initialData.columns.map((fallbackColumn, index) => {
        const fromSource =
            sourceColumns.find((column) => column?.id === fallbackColumn.id) ||
            sourceColumns[index] ||
            fallbackColumn;
        return sanitizeColumn(fromSource, fallbackColumn);
    });

    return {
        sectionTitle: (source.sectionTitle || initialData.sectionTitle || '').toString(),
        columns
    };
};

export const LinksProvider = ({ children }) => {
    const [linksData, setLinksData] = useState(initialData);
    const [loading, setLoading] = useState(true);

    // Load from DB on mount
    useEffect(() => {
        const fetchLinks = async () => {
            try {
                // Strategy: Try loading Check v3 (Sharded) first
                // This bypasses the WAF 8KB limit by splitting data
                const [meta, col1, col2, col3, col4] = await Promise.all([
                    getPageContent('services_v3_meta'),
                    getPageContent('services_v3_col1'),
                    getPageContent('services_v3_col2'),
                    getPageContent('services_v3_col3'),
                    getPageContent('services_v3_col4')
                ]);

                if (meta && col1 && col2 && col3 && col4) {
                    // Successfully found v3 data, reconstruct
                    setLinksData(sanitizeLinksData({
                        sectionTitle: meta.sectionTitle,
                        columns: [col1, col2, col3, col4]
                    }));
                    setLoading(false);
                    return;
                }

                // Fallback: Legacy v2 (Single Block)
                const data = await getPageContent('services_section_v2');
                if (data && data.columns) {
                    setLinksData(sanitizeLinksData(data));
                } else {
                    // Initial save if DB is empty
                    // We save to v3 structure immediately to avoid future issues
                    await updateLinksData(initialData);
                }
            } catch (error) {
                console.error("Failed to load services content:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchLinks();
    }, []);

    const updateLinksData = async (newData) => {
        const sanitizedData = sanitizeLinksData(newData);
        setLinksData(sanitizedData);
        try {
            // Sharding Strategy: Save as 5 small files instead of 1 big file
            // This keeps each payload under the CloudFront 8KB WAF limit

            const meta = { sectionTitle: sanitizedData.sectionTitle };
            // Find columns by ID (robustness) or index
            const col1 = sanitizedData.columns.find(c => c.id === 'col1') || sanitizedData.columns[0];
            const col2 = sanitizedData.columns.find(c => c.id === 'col2') || sanitizedData.columns[1];
            const col3 = sanitizedData.columns.find(c => c.id === 'col3') || sanitizedData.columns[2];
            const col4 = sanitizedData.columns.find(c => c.id === 'col4') || sanitizedData.columns[3];

            await Promise.all([
                savePageContent('services_v3_meta', meta),
                savePageContent('services_v3_col1', col1),
                savePageContent('services_v3_col2', col2),
                savePageContent('services_v3_col3', col3),
                savePageContent('services_v3_col4', col4)
            ]);

            // Optional: We DON'T save to services_section_v2 anymore to avoid the error.

        } catch (error) {
            console.error("Failed to save services content:", error);
            throw error;
        }
    };

    return (
        <LinksContext.Provider value={{ linksData, updateLinksData, loading }}>
            {children}
        </LinksContext.Provider>
    );
};

export const useLinks = () => useContext(LinksContext);
